import React from "react";
import { Box, Typography, Select, MenuItem, Stack, IconButton } from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import { AI_DETECTION_ROWS_PER_PAGE_OPTIONS } from "../../constants/aiDetectionPagination";

/**
 * Shared pagination bar for Alert Dashboard, Alert History, and Alert Rules.
 */
export function AlertServicesPaginationFooter({
  total,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  sx = {},
}) {
  const rangeLabel =
    total === 0
      ? "0–0 of 0"
      : `${(page - 1) * rowsPerPage + 1}–${Math.min(
          page * rowsPerPage,
          total,
        )} of ${total}`;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1.5,
        px: 2,
        py: 1.25,
        backgroundColor: "#F5F5F5",
        borderTop: "1px solid #E8E8E8",
        ...sx,
      }}
    >
      <Typography
        component="div"
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          color: "#616161",
        }}
      >
        Total Items:{" "}
        <Box component="span" sx={{ fontWeight: 700, color: "#212121" }}>
          {total}
        </Box>
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: "14px",
            color: "#616161",
          }}
        >
          Rows per page:
        </Typography>
        <Select
          size="small"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          variant="outlined"
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: "14px",
            minWidth: 72,
            height: 34,
            backgroundColor: "#fff",
            borderRadius: "6px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E0E0E0",
            },
            "& .MuiSelect-select": { py: 0.75 },
          }}
        >
          {AI_DETECTION_ROWS_PER_PAGE_OPTIONS.map((n) => (
            <MenuItem key={n} value={n}>
              {n}
            </MenuItem>
          ))}
        </Select>
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: "14px",
            color: "#616161",
            ml: 0.5,
          }}
        >
          {rangeLabel}
        </Typography>
        <IconButton
          size="small"
          disabled={page <= 1}
          onClick={() => onPageChange((p) => Math.max(1, p - 1))}
          aria-label="Previous page"
          sx={{ color: page <= 1 ? "#BDBDBD" : "#616161" }}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          disabled={page * rowsPerPage >= total}
          onClick={() => onPageChange((p) => p + 1)}
          aria-label="Next page"
          sx={{
            color: page * rowsPerPage >= total ? "#BDBDBD" : "#616161",
          }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
}
